import { useLeadStore } from "..";
import { showErrorToast } from "../components/ToastContainer";

const useLeadNoteCreate = (): (leadId: number, text: string) => Promise<void> => {
    const leadStore = useLeadStore();

    return async (leadId: number, text: string): Promise<void> => {
        try {
            await leadStore.createLeadNote(leadId, text);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeadNoteCreate;
